"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _BuildingAddStaffModal = _interopRequireDefault(require("./BuildingAddStaffModal.vue"));
var BuildingStaffImport = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(BuildingStaffImport, _Vue);
  var _super = (0, _createSuper2.default)(BuildingStaffImport);
  function BuildingStaffImport() {
    var _this;
    (0, _classCallCheck2.default)(this, BuildingStaffImport);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildingId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    return _this;
  }
  (0, _createClass2.default)(BuildingStaffImport, [{
    key: "onSubmitOk",
    value: function onSubmitOk() {
      return "";
    }
  }]);
  return BuildingStaffImport;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], BuildingStaffImport.prototype, "buildingId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("submit:ok")], BuildingStaffImport.prototype, "onSubmitOk", null);
BuildingStaffImport = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    BuildingAddStaffModal: _BuildingAddStaffModal.default
  }
})], BuildingStaffImport);
var _default = BuildingStaffImport;
exports.default = _default;